export default __webpack_public_path__ + "static/media/plain-sticker-d.c06dcf7e.png";